import React, { Component } from 'react'
import Bridge from '../../../utils/Bridge';
import moment from 'moment';
import { RESEARCH_TYPE } from '../../../utils/consts';
import { translateApiMessage } from '../../../utils/functions';
import { message, Spin,Switch } from 'antd';
import Header from '../../../layout/Header';
import Footer from '../../../layout/Footer';

import englishJson from '../../../utils/language/leStudy/english.json';
import spanishJson from '../../../utils/language/leStudy/spanish.json';

export default class CreateAccount extends Component {
    // state list
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      email: "",
      phone_no: "",
      consent_status: "",
      relation_to_als: "",
      referred_by: "",
      language_preference: "",
      language: "",

      password: "",
      retype_password: "",
      loading: false,
      type1: "password",
      type2: "password",
      selectedToggleLanguage: "English"
    };
  }
  // signup user
  signupUser = (neurostamp_id) => {
    let language = ''
    if(this.state.language_preference === "I'd like to do speech tasks in Spanish only; I am not confident in English"){
      language = "Spanish";
    }else{
      language = this.state.language;
    }
    let params = {
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      email: this.state.email,
      phone_no: this.state.phone_no,
      consent_status: "New",
      relation_to_als: this.state.relation_to_als,
      referred_by: this.state.referred_by,
      language_preference: this.state.language_preference,
      language: language,
      date_joined: moment().format("MM/DD/YYYY"),
      neurostamp_id: neurostamp_id,
      password: this.state.password,
    };
    if (RESEARCH_TYPE == "LE Study") {
      this.setState({ loading: true });
      Bridge.participants.le_study
        .save_participant(params)
        .then((response) => {
          const currentLanguage = this.getCurrentLanguage();
          if (response.status == 1) {
            message.success(translateApiMessage(response.message, currentLanguage));
            this.setState({ loading: false });
            setTimeout(() => {
              window.location.assign("/");
            }, 2000);
          } else {
            message.warning(translateApiMessage(response.message, currentLanguage));
            this.setState({ loading: false });
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    }else{
        const formData = this.getFormData();
        const currentLanguage = this.getCurrentLanguage();
        message.warning(translateApiMessage(formData.page.createAccount.error.unauthorized, currentLanguage));
        this.setState({ loading: false });
    }
  };
  generate_neurostamp_id = (retryCount = 0) => {
    const formData = this.getFormData();
    const language = this.getCurrentLanguage();
    
    if (!this.state.first_name) {
      message.warning(translateApiMessage(formData.page.createAccount.messages.validation.firstNameRequired, language));
      return;
    } else if (!this.state.last_name) {
      message.warning(translateApiMessage(formData.page.createAccount.messages.validation.lastNameRequired, language));
      return;
    }  
    if (!this.state.email) {
      message.warning(translateApiMessage(formData.page.createAccount.messages.validation.emailRequired, language));
      return;
    }
    if(this.state.email && this.state.email !== ""){
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(this.state.email)) {
        message.warning(translateApiMessage(formData.page.createAccount.messages.validation.emailInvalid, language));
        return;
      }
    }
    if (!this.state.relation_to_als) {
      message.warning(translateApiMessage(formData.page.createAccount.messages.validation.relationToAlsRequired, language));
      return;
    }
    if (!this.state.language_preference) {
      message.warning(translateApiMessage(formData.page.createAccount.messages.validation.languagePreferenceRequired, language));
      return;
    }
    if(this.state.language_preference === "I am comfortable with speech tasks in both languages"){
      if (!this.state.language) {
        message.warning(translateApiMessage(formData.page.createAccount.messages.validation.languageRequired, language));
        return;
      }
    }
    let password = this.state.password;
    let retype_password = this.state.retype_password;
    if (!password || !retype_password) {
      message.warning(translateApiMessage(formData.page.createAccount.messages.validation.passwordRequired, language));
      return;
    }
    if (password !== retype_password) {
      message.warning(translateApiMessage(formData.page.createAccount.messages.validation.passwordMismatch, language));
      return;
    }
    let lowerCaseLetters = /[a-z]/g;
    let upperCaseLetters = /[A-Z]/g;
    let numbers = /[0-9]/g;
    let specialCharacters = /[!@#\$%\^&\*]/g;
    if (!password.match(lowerCaseLetters)) {
      message.warning(translateApiMessage(formData.page.createAccount.messages.validation.passwordLowercase, language));
      return;
    }
    if (!password.match(upperCaseLetters)) {
      message.warning(translateApiMessage(formData.page.createAccount.messages.validation.passwordUppercase, language));
      return;
    }
    if (!password.match(numbers)) {
      message.warning(translateApiMessage(formData.page.createAccount.messages.validation.passwordNumber, language));
      return;
    }
    if (!password.match(specialCharacters)) {
      message.warning(translateApiMessage(formData.page.createAccount.messages.validation.passwordSpecialChar, language));
      return;
    }
    if (password.length < 8) {
      message.warning(translateApiMessage(formData.page.createAccount.messages.validation.passwordLength, language));
      return;
    }
    let params = {
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      middle_name: "NOTAPPLICABLE",
      email: this.state.email,
      year_of_birth: "",
      day_of_birth: "",
      sex_at_birth: "",
      month_of_birth: "",
      country_of_birth: "",
      city_of_birth: "",
    };
    this.setState({ loading: true });
    Bridge.participants.speech
      .generate_neurostamp_id(params)
      .then((result) => {
        if (result.status == 1 && result.data) {
          this.signupUser(result.data);
        } else {
          // if (retryCount < 3) {
          //   setTimeout(() => {
          //     this.generate_neurostamp_id(retryCount + 1);
          //   }, 2000);
          // } else {
            const formData = this.getFormData();
            const language = this.getCurrentLanguage();
            message.warning(translateApiMessage(formData.page.createAccount.messages.validation.neurostampFailed, language) + " is not generated. Please try again.");
            this.setState({ loading: false });
          // }
        }
      })
      .catch((error) => {
        if (error) {
          // if (retryCount < 3) {
          //   setTimeout(() => {
          //     this.generate_neurostamp_id(retryCount + 1);
          //   }, 2000);
          // } else {
            setTimeout(() => {
              const formData = this.getFormData();
              const language = this.getCurrentLanguage();
              message.warning(
                translateApiMessage(formData.page.createAccount.messages.validation.neurostampFailed, language) + " is not generated. Please try again."
              );
              this.setState({ loading: false });
            }, 30000);
          // }
        } else {
          this.setState({ loading: false });
        }
      });
  };
  // on change inputs
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  // show hide password
  togglePassword = (num) => {
    if (num == "1") {
      this.setState({
        type1: this.state.type1 == "password" ? "text" : "password",
      });
    } else if (num == "2") {
      this.setState({
        type2: this.state.type2 == "password" ? "text" : "password",
      });
    }
  };
  handleLanguageChange = (value) => {
    this.setState({
      selectedToggleLanguage: value,
    });
  };
  // Helper method to get form data based on selected language
  getFormData = () => {
    return this.state.selectedToggleLanguage === "English" ? englishJson : spanishJson;
  };
  // Helper method to get current language
  getCurrentLanguage = () => {
    return this.state.language || this.state.selectedToggleLanguage || "English";
  };
  render() {
    let formData = this.getFormData();
    return (
      <>
        <Header selectedLanguage={this.state.selectedToggleLanguage} />
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
        <div className="authenitication-form">
            <div className="dark-side d-none d-sm-none d-md-none d-lg-block d-xl-block">
                <img src={"./assets/images/dark-logo.jpg"} />
                <p
                className="inner-text"
                style={{ fontSize: 18, fontWeight: "500" }}
                >
                {formData.page.createAccount.missionStatement}
                </p>
            </div>
            <div className="right-sides-form">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                        <h2>{formData.page.createAccount.title}</h2>
                        <div className="">
                            <Spin spinning={this.state.loading}>
                                <div className="form-wrapper">

                                     <div className="col-lg-6 mb-5">
                                        <div className="form-field">
                                            <label style={{width: "fit-content"}}>
                                                {formData.page.createAccount.form.languageLabel} &nbsp;&nbsp;&nbsp;
                                                <Switch
                                                    checkedChildren={<b>English</b>}
                                                    unCheckedChildren={<b>Spanish</b>}
                                                    defaultChecked
                                                    checked={this.state.selectedToggleLanguage === "English"}
                                                    onChange={(e) => this.handleLanguageChange(e ? "English" : "Spanish")}
                                                />
                                            </label>
                                        </div>
                                    </div>
                                    
                                    <div className="row">
                                    <div className="col-lg-6">
                                        <div className="form-field">
                                        <label>
                                            <box-icon
                                            type="solid"
                                            name="user"
                                            color="#9e9e9e"
                                            size={
                                                window.innerWidth > 600
                                                ? "23px"
                                                : "23px"
                                            }
                                            style={{
                                                marginTop:
                                                window.innerWidth > 600 ? 0 : -3,
                                                marginRight:
                                                window.innerWidth > 600 ? 12 : 9,
                                            }}
                                            ></box-icon>{" "}
                                            {formData.page.createAccount.form.fields.firstName.label}{" "}
                                            <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="first_name"
                                            value={this.state.first_name}
                                            onChange={(e) =>
                                            this.setState({
                                                first_name: e.target.value,
                                            })
                                            }
                                        />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-field">
                                        <label>
                                            <box-icon
                                            type="solid"
                                            name="user"
                                            color="#9e9e9e"
                                            size={
                                                window.innerWidth > 600
                                                ? "23px"
                                                : "23px"
                                            }
                                            style={{
                                                marginTop:
                                                window.innerWidth > 600 ? 0 : -3,
                                                marginRight:
                                                window.innerWidth > 600 ? 12 : 9,
                                            }}
                                            ></box-icon>{" "}
                                            {formData.page.createAccount.form.fields.lastName.label}{" "}
                                            <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="last_name"
                                            value={this.state.last_name}
                                            onChange={this.handleChange}
                                        />
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-field">
                                        <label>
                                            <box-icon
                                            type="solid"
                                            name="envelope"
                                            color="#9e9e9e"
                                            size={
                                                window.innerWidth > 600
                                                ? "23px"
                                                : "23px"
                                            }
                                            style={{
                                                marginTop:
                                                window.innerWidth > 600 ? 0 : -3,
                                                marginRight:
                                                window.innerWidth > 600 ? 12 : 9,
                                            }}
                                            ></box-icon>{" "}
                                            {formData.page.createAccount.form.fields.email.label}{" "}
                                            <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="email"
                                            value={this.state.email}
                                            onChange={this.handleChange}
                                            style={{ marginBottom: 3 }}
                                        />
                                        <p
                                            style={{
                                            fontSize: 14,
                                            color: "#868e96",
                                            }}
                                        >
                                            {formData.page.createAccount.form.fields.email.helpText}
                                        </p>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-field mt-2">
                                        <label>
                                            <box-icon
                                            type="solid"
                                            name="phone"
                                            color="#9e9e9e"
                                            size={
                                                window.innerWidth > 600
                                                ? "23px"
                                                : "23px"
                                            }
                                            style={{
                                                marginTop:
                                                window.innerWidth > 600 ? 0 : -3,
                                                marginRight:
                                                window.innerWidth > 600 ? 12 : 9,
                                            }}
                                            ></box-icon>{" "}
                                            {formData.page.createAccount.form.fields.phoneNo.label}
                                        </label>
                                        <input
                                          type="number"
                                          name="phone_no"
                                          value={this.state.phone_no}
                                          onChange={this.handleChange}
                                          style={{ marginBottom: 3 }}
                                        />
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-field mt-3">
                                        <label>
                                            <box-icon
                                            style={{
                                                marginTop:
                                                window.innerWidth > 600 ? 0 : -3,
                                                marginRight:
                                                window.innerWidth > 600 ? 12 : 9,
                                            }}
                                            name="lock-alt"
                                            type="solid"
                                            color="#9e9e9e"
                                            size={
                                                window.innerWidth > 600
                                                ? "23px"
                                                : "23px"
                                            }
                                            ></box-icon>
                                            {formData.page.createAccount.form.fields.password.label}{" "}
                                            <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type={this.state.type1}
                                            name="password"
                                            value={this.state.password}
                                            onChange={this.handleChange}
                                        />
                                        <div
                                            className="togglePassword"
                                            onClick={() => this.togglePassword(1)}
                                        >
                                            {this.state.type1 == "password" ? (
                                            <div className="show-password-icon">
                                                <box-icon
                                                name="show"
                                                color="#ffa3a3"
                                                ></box-icon>
                                            </div>
                                            ) : (
                                            <div className="show-password-icon">
                                                <box-icon
                                                name="low-vision"
                                                color="#ffa3a3"
                                                ></box-icon>
                                            </div>
                                            )}
                                        </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-field">
                                        <label>
                                            <box-icon
                                            style={{
                                                marginTop:
                                                window.innerWidth > 600 ? 0 : -3,
                                                marginRight:
                                                window.innerWidth > 600 ? 12 : 9,
                                            }}
                                            name="lock-alt"
                                            type="solid"
                                            color="#9e9e9e"
                                            size={
                                                window.innerWidth > 600
                                                ? "23px"
                                                : "23px"
                                            }
                                            ></box-icon>
                                            {formData.page.createAccount.form.fields.retypePassword.label}{" "}
                                            <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type={this.state.type2}
                                            name="retype_password"
                                            value={this.state.retype_password}
                                            onChange={this.handleChange}
                                        />
                                        <div
                                            className="togglePassword"
                                            onClick={() => this.togglePassword(2)}
                                        >
                                            {this.state.type2 == "password" ? (
                                            <div className="show-password-icon">
                                                <box-icon
                                                name="show"
                                                color="#ffa3a3"
                                                ></box-icon>
                                            </div>
                                            ) : (
                                            <div className="show-password-icon">
                                                <box-icon
                                                name="low-vision"
                                                color="#ffa3a3"
                                                ></box-icon>
                                            </div>
                                            )}
                                        </div>
                                        </div>
                                    </div>
                                    <div className="password-conditions">
                                        <p>
                                        {formData.page.createAccount.form.passwordRequirements.title}
                                        </p>
                                        <ul>
                                        <li>{formData.page.createAccount.form.passwordRequirements.requirements[0]}</li>
                                        <li>{formData.page.createAccount.form.passwordRequirements.requirements[1]}</li>
                                        <li>{formData.page.createAccount.form.passwordRequirements.requirements[2]}</li>
                                        <li>{formData.page.createAccount.form.passwordRequirements.requirements[3]}</li>
                                        <li>
                                            {formData.page.createAccount.form.passwordRequirements.requirements[4]}
                                        </li>
                                        </ul>
                                        <p>
                                        {formData.page.createAccount.form.passwordRequirements.requirements[5]}
                                        </p>
                                        {formData.page.createAccount.form.passwordRequirements.note}
                                    </div>

                                    <div className="col-lg-12">
                                        <div className="form-field mt-4">
                                        <label>
                                            <box-icon
                                            style={{
                                                marginTop:
                                                window.innerWidth > 600 ? 0 : -3,
                                                marginRight:
                                                window.innerWidth > 600 ? 12 : 9,
                                            }}
                                            name="purchase-tag"
                                            type="solid"
                                            color="#9e9e9e"
                                            size={
                                                window.innerWidth > 600
                                                ? "23px"
                                                : "23px"
                                            }
                                            ></box-icon>
                                            {formData.page.createAccount.form.fields.relationToAls.label} {" "}
                                            <span className="text-danger">*</span>
                                        </label>
                                        <select
                                            name="relation_to_als"
                                            value={this.state.relation_to_als}
                                            onChange={this.handleChange}
                                            className="mt-2 create-select-option w-100"
                                        >
                                            <option value="">
                                            {formData.page.createAccount.form.fields.relationToAls.placeholder}
                                            </option>
                                            {formData.page.createAccount.form.fields.relationToAls.options.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                        </div>
                                    </div>

                                    {RESEARCH_TYPE === "LE Study" && (
                                        <div className="col-lg-12">
                                        <div className="form-field mt-4">
                                            <label className="align-items-start">
                                            <box-icon
                                                style={{
                                                marginTop:
                                                    window.innerWidth > 600 ? 0 : -3,
                                                marginRight:
                                                    window.innerWidth > 600 ? 12 : 9,
                                                }}
                                                name="globe"
                                                type="solid"
                                                color="#9e9e9e"
                                                size={
                                                window.innerWidth > 600
                                                    ? "23px"
                                                    : "23px"
                                                }
                                            ></box-icon>
                                            {formData.page.createAccount.form.fields.languagePreference.label}{" "}
                                            <span className="text-danger">*</span>
                                            </label>
                                            <select
                                            name="language_preference"
                                            value={this.state.language_preference}
                                            onChange={(e) => {
                                                this.setState({
                                                language_preference: e.target.value,
                                                language:"",
                                                });
                                            }}
                                            className="mt-2 create-select-option w-100"
                                            >
                                            <option value="">
                                                {formData.page.createAccount.form.fields.languagePreference.placeholder}
                                            </option>
                                            {formData.page.createAccount.form.fields.languagePreference.options.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                            </select>
                                        </div>
                                        {this.state.language_preference === formData.page.createAccount.form.fields.languagePreference.options[0].value && (
                                            <div className="form-field mt-4">
                                            <label> 
                                                <box-icon
                                                style={{
                                                    marginTop:
                                                    window.innerWidth > 600 ? 0 : -3,
                                                    marginRight:
                                                    window.innerWidth > 600 ? 12 : 9,
                                                }}
                                                name="globe"
                                                type="solid"
                                                color="#9e9e9e"
                                                size={
                                                    window.innerWidth > 600
                                                    ? "23px"
                                                    : "23px"
                                                }
                                                ></box-icon>
                                                {formData.page.createAccount.form.fields.language.label}{" "}
                                                <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                name="language"
                                                value={this.state.language}
                                                onChange={(e)=>this.setState({language:e.target.value})}
                                                className="mt-2 create-select-option w-100"
                                            >
                                                {formData.page.createAccount.form.fields.language.options.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                            </div>
                                        )}
                                        </div>
                                    )}
                                    </div>

                                    <br />

                                    <center>
                                    <button
                                        type="button"
                                        className="create-new-account-button"
                                        onClick={() => this.generate_neurostamp_id()}
                                    >
                                        <box-icon
                                        type="solid"
                                        name="user-plus"
                                        color="#fff"
                                        size={"25px"}
                                        ></box-icon>
                                        &nbsp; <span>{formData.page.createAccount.form.buttons.createAccount}</span>
                                    </button>
                                    </center>
                                    <span
                                    className="extra-link-with-text"
                                    style={{ top: 30 }}
                                    >
                                    {formData.page.createAccount.form.links.alreadyHaveAccount} &nbsp;
                                    <a href="/">{formData.page.createAccount.form.links.signIn}</a>
                                    </span>
                                </div>
                            </Spin>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            </div>
          </div>
        </div>

        <Footer formData={formData} key={this.state.selectedToggleLanguage} />
      </>
    )
  }
}
